import { Day, TimeSlot } from "@/features/planner/api/planner";
import { UtensilsCrossed, CloudSun, Coffee, Salad, Utensils } from "lucide-react";

interface PlanQuickInfoProps {
    day: Day;
    timeSlot: TimeSlot;
    timeSlotName: 'morning' | 'afternoon' | 'evening';
}

export const PlanQuickInfo = ({ day, timeSlot, timeSlotName }: PlanQuickInfoProps) => {
    const { notes } = day;

    // Determine which meal to show based on time of day
    const getMealInfo = () => {
        switch (timeSlotName) {
            case 'morning':
                return notes?.breakfast_suggestion ? {
                    icon: Coffee,
                    title: 'Breakfast',
                    suggestion: notes?.breakfast_suggestion
                } : null;
            case 'afternoon':
                return notes?.lunch_suggestion ? {
                    icon: Salad,
                    title: 'Lunch',
                    suggestion: notes?.lunch_suggestion
                } : null;
            case 'evening':
                return notes?.dinner_suggestion ? {
                    icon: Utensils,
                    title: 'Dinner',
                    suggestion: notes?.dinner_suggestion
                } : null;
        }
    };

    const mealInfo = getMealInfo();
    const MealIcon = mealInfo?.icon;

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div className="bg-white p-6 rounded-2xl shadow-[0_2px_8px_rgba(0,0,0,0.05)] border border-slate-100 h-full">
                <div className="flex items-center gap-3 mb-4">
                    <UtensilsCrossed className="w-7 h-7 text-[#187A85]" />
                    <h3 className="text-xl font-bold text-[#1e293b]">Food & Culture</h3>
                </div>
                {mealInfo && MealIcon ? (
                    <div className="space-y-1">
                        <div className="flex items-center gap-2">
                            <MealIcon className="w-4 h-4 text-[#E76828]" />
                            <h4 className="text-sm font-semibold text-[#1e293b]">{mealInfo.title}</h4>
                        </div>
                        <p className="text-slate-600 text-sm leading-relaxed">
                            {mealInfo.suggestion}
                        </p>
                    </div>
                ) : (
                    <p className="text-slate-400 text-sm">No meal suggestion available for this time.</p>
                )}
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-[0_2px_8px_rgba(0,0,0,0.05)] border border-slate-100 h-full">
                <div className="flex items-center gap-3 mb-4">
                    <CloudSun className="w-7 h-7 text-[#187A85]" />
                    <h3 className="text-xl font-bold text-[#1e293b]">Weather Tips</h3>
                </div>
                <p className="text-slate-600 text-sm leading-relaxed">
                    {timeSlot.weather_tips}
                </p>
            </div>
        </div>
    );
};
